import React, { useState, useMemo } from "react";
import { useHistory } from "react-router-dom";

import { connect } from "react-redux";
import { frontloadConnect } from "react-frontload";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";

import { getBanner } from "./../../store/banner.reducers";
import { getTeam } from "./../../store/team.reducers";

import Header from "./../../components/Header";
import Featured from "./../../components/Featured";
import Title from "./../../components/Title";
import Newsletter from "./../../components/Newsletter";
import Footer from "./../../components/Footer";
import MainServices from "./../../components/MainServices";

import email2 from "./../../assets/icons/email2.svg";
import company from "./../../assets/icons/company.svg";
import phone2 from "./../../assets/icons/phone2.svg";
import whatsapp from "./../../assets/icons/whatsapp.svg";

import { stripAccents } from "./../../services/functions";

import {
  Main,
  Container,
  Content,
  HeaderSection,
  HeaderTitle,
  SearchSection,
  SearchInput,
  DepartmentsContainer,
  DepartmentSection,
  DepartmentTitle,
  DepartmentTable,
  TableHeader,
  TableRow,
  TableCell,
  TableHeaderCell,
  MobileCard,
  MobileCardContent,
  MobileCardTitle,
  MobileCardSubtitle,
  MobileCardInfo,
  GlobalMobileStyles,
} from "./styles";

let PATH = "/equipe-tecnica/";
const frontload = async props => {
  await props.getTeam(`${process.env.REACT_APP_API}/teams`, {
    headers: { pagenumber: props.match.params.page || 1, pagelimit: 10, term: stripAccents(props.match.params.filter || "") },
  });
  return;
};

function Team(props) {
  if (props.match.params.filter) {
    PATH = `/equipe-tecnica/buscar/${props.match.params.filter}/`;
  }
  let { teamReducers: team } = useSelector(state => state);
  team = team.team.data;

  const [filterTerm, setFilterTerm] = useState("");
  const history = useHistory();

  // Filtrar e agrupar membros por departamento
  const groupedTeam = useMemo(() => {
    const groups = {};

    // Filtrar membros baseado no termo de busca
    const filteredTeam = team.filter(member => {
      if (!filterTerm) return true;

      // Normalizar o termo de busca removendo acentos
      const searchTerm = stripAccents(filterTerm.toLowerCase());

      // Normalizar todos os campos de busca removendo acentos
      const name = stripAccents((member.name || "").toLowerCase());
      const occupation = stripAccents((member.occupation || "").toLowerCase());
      const department = stripAccents((member.department || "").toLowerCase());
      const email = stripAccents((member.email || "").toLowerCase());

      return name.includes(searchTerm) || occupation.includes(searchTerm) || department.includes(searchTerm) || email.includes(searchTerm);
    });

    // Agrupar membros filtrados por departamento
    filteredTeam.forEach(member => {
      const department = member.department || "Outros";
      if (!groups[department]) {
        groups[department] = [];
      }
      groups[department].push(member);
    });

    return groups;
  }, [team, filterTerm]);

  return (
    <>
      <Helmet>
        <title>Conheça nossa equipe técnica - {process.env.REACT_APP_TITLE}</title>
        <meta name="description" content={process.env.REACT_APP_DESCRIPTION} />
        <meta property="og:title" content={`Conheça nossa equipe técnica - ${process.env.REACT_APP_TITLE}`} />
        <meta name="title" content={`Conheça nossa equipe técnica - ${process.env.REACT_APP_TITLE}`} />
        <meta property="og:description" content={process.env.REACT_APP_DESCRIPTION} />
        <meta property="og:image" content="https://cromt.org.br/logo512.png" />
        <meta property="og:site_name" content="CRO-MT" />
        <meta property="og:url" content={global.window ? global.window.location : ""} />
      </Helmet>
      <GlobalMobileStyles />
      <Header />

      <Main id="main">
        <Container>
          <Content>
            <HeaderSection>
              <HeaderTitle>Equipe Técnica – CRO-MT</HeaderTitle>
            </HeaderSection>

            <SearchSection>
              <SearchInput
                type="text"
                placeholder="Buscar por nome, função ou setor..."
                value={filterTerm}
                onChange={event => setFilterTerm(event.target.value)}
              />
            </SearchSection>

            <DepartmentsContainer>
              {Object.keys(groupedTeam).length === 0 ? (
                <div
                  style={{
                    textAlign: "center",
                    padding: "40px 20px",
                    color: "#666666",
                    fontFamily: "NunitoSans-Regular",
                    fontSize: "18px",
                  }}>
                  {filterTerm ? `Nenhum resultado encontrado para "${filterTerm}"` : "Nenhum membro da equipe encontrado"}
                </div>
              ) : (
                Object.keys(groupedTeam).map(department => (
                  <DepartmentSection key={department}>
                    <DepartmentTitle>{department}</DepartmentTitle>

                    {/* Desktop Table View */}
                    <DepartmentTable className="desktop-table">
                      <TableHeader>
                        <TableRow>
                          <TableHeaderCell>Nome</TableHeaderCell>
                          <TableHeaderCell>Cargo</TableHeaderCell>
                          <TableHeaderCell>E-mail</TableHeaderCell>
                          <TableHeaderCell>Telefone</TableHeaderCell>
                          {/* <TableHeaderCell>WhatsApp</TableHeaderCell> */}
                        </TableRow>
                      </TableHeader>
                      <tbody>
                        {groupedTeam[department].map(member => (
                          <TableRow key={member.id}>
                            <TableCell>{member.name}</TableCell>
                            <TableCell>{member.occupation}</TableCell>
                            <TableCell>{member.email || "email não informado"}</TableCell>
                            <TableCell>{member.phones || "não informado"}</TableCell>
                            {/* <TableCell>
                              {member.whatsapp ? (
                                <a target="_blank" href={`https://wa.me/55${member.whatsapp.replace(/\D/g, "")}`}>
                                  {member.whatsapp}
                                </a>
                              ) : (
                                "n/a"
                              )}
                            </TableCell> */}
                          </TableRow>
                        ))}
                      </tbody>
                    </DepartmentTable>

                    {/* Mobile Card View */}
                    <div className="mobile-cards">
                      {groupedTeam[department].map(member => (
                        <MobileCard key={member.id}>
                          <MobileCardContent>
                            <MobileCardTitle>{member.name}</MobileCardTitle>
                            <MobileCardSubtitle>{member.occupation}</MobileCardSubtitle>
                            <MobileCardInfo>
                              <div>
                                <strong>E-mail:</strong> {member.email || "email não informado"}
                              </div>
                              {/* <div>
                                <strong>Telefone:</strong> {member.phones || "n/a"}
                              </div> */}
                              <div>
                                <strong>WhatsApp:</strong>{" "}
                                {member.whatsapp ? (
                                  <a target="_blank" href={`https://wa.me/55${member.whatsapp.replace(/\D/g, "")}`}>
                                    {member.whatsapp}
                                  </a>
                                ) : (
                                  "n/a"
                                )}
                              </div>
                            </MobileCardInfo>
                          </MobileCardContent>
                        </MobileCard>
                      ))}
                    </div>
                  </DepartmentSection>
                ))
              )}
            </DepartmentsContainer>
          </Content>
        </Container>
        <Newsletter />
      </Main>
      <Footer />
    </>
  );
}

// export default Home
const mapStateToProps = state => {
  return {
    banner: state.bannerReducers.banner,
    team: state.teamReducers.team,
  };
};
const mapDispatchToProps = {
  getBanner,
  getTeam,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  frontloadConnect(frontload, {
    onMount: true,
    onUpdate: false,
  })(Team),
);
